import CryptoJS from 'crypto-js';

const PRHASE = 'LjksEut56uYakbtsj896KJ6GHpfTeCD';


export const crypt = (content) => {
    return CryptoJS.AES.encrypt(content, PRHASE).toString();
}


export const decrypt = (encrypted) => {
    let decryptedBytes = CryptoJS.AES.decrypt(encrypted, PRHASE);
    return decryptedBytes.toString(CryptoJS.enc.Utf8);
}